import './breadcrumbs.scss';

/**
 * version    1.0
 * class      <type> (Breadcrumbs)
 * classdesc
 */
export class Breadcrumbs {}
